import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { pauseReasonsTemplate } from 'apollo/templates/organization/query.graphql';

/** Denthub's default pause reasons, used until a lab saves its own list. */
export const DEFAULT_PAUSE_REASON_KEYS = [
    'workflow:PAUSE_REASON_CALL_DENTIST',
    'workflow:PAUSE_REASON_NO_ANSWER_FROM_DENTIST',
    'workflow:PAUSE_REASON_WAITING_FOR_NEW_SCAN',
    'workflow:PAUSE_REASON_PAUSED_DUE_TO_PATIENT',
];

/**
 * The lab's pause reasons in display order. The backend returns null while the
 * lab is on the defaults, which are translated here into the user's language.
 */
export const usePauseReasons = (options: { skip?: boolean } = {}) => {
    const { t: translate } = useTranslation(['workflow']);
    const { data, loading, error, refetch } = useQuery<{ pauseReasons: string[] | null }>(pauseReasonsTemplate, {
        skip: options.skip,
        fetchPolicy: 'cache-and-network',
    });

    const isDefault = !loading && !error && data?.pauseReasons == null;
    const pauseReasons =
        data?.pauseReasons ?? (isDefault ? DEFAULT_PAUSE_REASON_KEYS.map((key) => translate(key)) : []);

    return { pauseReasons, isDefault, loading, error, refetch };
};
